import * as actionType from '../constants/constant.action'

export interface ExtendReferralState {
  requestMade: boolean
  responseReceived: boolean
  failureResponse?: any
  successResponse?: any
}

const defaultState: ExtendReferralState = {
  requestMade: false,
  responseReceived: false,
  failureResponse: undefined,
  successResponse: undefined,
}

const extendReferralReducer = (
  state = defaultState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case actionType.EXTEND_REFERRAL:
      return {
        ...state,
        requestMade: true,
      }
    case actionType.EXTEND_REFERRAL_FAILURE:
      return {
        ...state,
        failureResponse: action.payload,
        successResponse: undefined,
        responseReceived: true,
      }
    case actionType.EXTEND_REFERRAL_SUCCESS:
      return {
        ...state,
        failureResponse: undefined,
        successResponse: action.payload,
        responseReceived: true,
      }
    case actionType.EXTEND_REFERRAL_CLOSE_MODAL:
      return {
        ...defaultState,
      }
    default:
      return state
  }
}

export default extendReferralReducer
